import { useEffect } from "react";
import Switch from "components/Switch"
import Button from "components/Button";
import getModuleName from "utils/getModuleName";

const items = [
   { name: "show_average", label: "Pokaż wartość średnią dla populacji" },
   { name: "dark_theme", label: "Włącz ciemny widok" },
   { name: "show_main_lines", label: "Wyświetl główne linie siatki" },
   { name: "show_auxiliary_lines", label: "Wyświetl pomocnicze linie siatki" }
]

export default function VisualizationOptionsBox({
   data,
   onChange,
   allow_average,
   hasCustomColors,
   onColorsReset,
   isCompareMode = false
}) {

   const module = getModuleName();

   useEffect(() => {

      const root = document.getElementById( "zskstat-browser-app" );
   
      if ( !data.dark_theme ) {
         document.body.style.background = "";
         root.setAttribute( "data-mode", undefined );
      } else {
         document.body.style.background = "#4E4E4E"
         root.setAttribute( "data-mode", "dark" );
      }
   }, [ data.dark_theme ]);

   return (
      <div className="box" style={{ display: "flex", flexDirection: "column", gap: "10px", flex: "1 1 450px" }}> 
         <h3 style={{ marginBottom: "4px" }}> Opcje wizualizacji </h3>
         
         { items.map(({ name, label }) => {

            if ( module === "AZZKU" && name === "show_average" ) return null;

            // UD: wyłącz średnią w porównywarce (wyniki merytorycznie nieprawidłowe) lub gdy allow_average === 0
            const disabled =
               module === "UD" &&
               name === "show_average" &&
               (isCompareMode ||
                  (allow_average !== null &&
                     allow_average !== undefined &&
                     Number(allow_average) === 0));

            return (
               <Switch
                  key={ name }
                  name={ name }
                  label={ label }
                  value={ !!data[ name ]}
                  onChange={ onChange }
                  disabled={ disabled }
               />
            )
         })}

         { hasCustomColors &&
            <Button
               label="Przywróć domyślne kolory"
               extra_classes="white"
               onClick={ onColorsReset }
            />
         }
      </div>
   )
}